var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordToolTip({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 290,
    height: 100.003,
    viewBox: "0 0 290 100.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Union_4",
    x: 0,
    y: 0,
    width: 290,
    height: 100.003,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17299",
    "data-name": "Group 17299",
    transform: "translate(-631.5 -472.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 631.5, 472.5)",
    filter: "url(#Union_4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union_4-2",
    "data-name": "Union 4",
    transform: "translate(4.5 3.5)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21.42121505737305 89.88868713378906 L 16.84453582763672 80.77737426757812 L 16.70614242553711 80.50180053710938 L 16.39775085449219 80.50180053710938 L 0.5 80.50180053710938 L 0.5 0.5000150799751282 L 280.5 0.5000150799751282 L 280.5 80.50180053710938 L 26.44467926025391 80.50180053710938 L 26.13628578186035 80.50180053710938 L 25.99789237976074 80.77737426757812 L 21.42121505737305 89.88868713378906 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21.42121505737305 88.77472686767578 L 25.82792854309082 80.00180053710938 L 280 80.00180053710938 L 280 1.000015139579773 L 1 1.000015139579773 L 1 80.00180053710938 L 17.01449966430664 80.00180053710938 L 21.42121505737305 88.77472686767578 M 21.42121505737305 91.00258636474609 L 16.39775085449219 81.00180053710938 L 2.842170943040401e-14 81.00180053710938 L 2.842170943040401e-14 1.509748199168826e-05 L 281 1.509748199168826e-05 L 281 81.00180053710938 L 26.44467926025391 81.00180053710938 L 21.42121505737305 91.00258636474609 Z",
    stroke: "none",
    fill: "#038de3"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Set_Your_New_Password:_Complete_required_fields_to_continue.",
    "data-name": "Set Your New Password: Complete required fields to continue.",
    transform: "translate(652 492)",
    fill: "#1d1d1f",
    fontSize: 16,
    fontFamily: "TitilliumWeb-SemiBold, Titillium Web",
    letterSpacing: "0.001em",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 18
  }, "Set Your New Password:")), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "TitilliumWeb-Regular, Titillium Web",
    fontWeight: 400
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 43
  }, "Complete required fields to continue."))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordToolTip);
export default __webpack_public_path__ + "static/media/passwordToolTip.a6d7040d180158039d89b635fd491cb5.svg";
export { ForwardRef as ReactComponent };